import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import "./LessonPlans.css";
import { Link } from "react-router-dom/cjs/react-router-dom";

function LessonPlan(props) {
  console.log(props);
  return (
    <Link
      to={`/lessonplans/edit?teacherId=${props.teacherId}&startDate=${new Date(
        props.plan?.startDate || "",
      ).toISOString()}&action=download&view=landscape`}
    >
      <div className="lessonPlan lessonPlan-wrapper">
        <h6>Period {props.plan.time || "Flexible"}</h6>
        <div className="plan-detail">
          <p>{`${props.plan.subjectId?.name || ""} > ${
            props.plan.chapterId?.name || props.plan?.customChapter || "-"
          } > ${props.plan.topicId?.name || props.plan?.customTopic || "-"}> ${
            props.plan?.customModule || "-"
          }`}</p>

          <span className="plan-grade">{`${
            props.plan?.sectionId?.grade || ""
          }-${props.plan?.sectionId?.section}`}</span>
        </div>
      </div>
    </Link>
  );
}

export default LessonPlan;
